import * as AppSetting from './app-settings';
const appSettings = AppSetting.default;
export default appSettings;
